import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountJulaProContactDetails';

const AccountJulaProContactDetailsSuspense = dynamic(
	() => import('./AccountJulaProContactDetails'),
	{
		loading: () => <BlockLoadingSpinner />,
	},
);

export default function DynamicAccountJulaProContactDetails(props: Props) {
	return <AccountJulaProContactDetailsSuspense {...props} />;
}
DynamicAccountJulaProContactDetails.displayName =
	'DynamicAccountJulaProContactDetails';
